<template>
  <AppLayout :show-app-preview="false">
    <template #default>
      <MultiStepForm :components="stepsComponents" />
    </template>
    <template #footer>
      <div class="registration">
        <router-link :to="{ name: 'login' }">
          {{ $t('signupPage.account-exist') }}
        </router-link>
      </div>
    </template>
  </AppLayout>
</template>

<script>
  import AppLayout from '@/components/AppLayout';
  import MultiStepForm from '@/components/MultiStepForm';
  import SignupAuthentication from '@/components/Signup/SignupAuthentication';
  import SignupIdentity from '@/components/Signup/SignupIdentity';
  import SignupPhone from '@/components/Signup/SignupPhone';
  import SignupAuthCode from '@/components/Signup/SignupAuthCode';

  export default {
    name: 'SignupPage',
    components: { MultiStepForm, AppLayout },
    computed: {
      stepsComponents() {
        return [
          SignupIdentity,
          SignupAuthentication,
          SignupPhone,
          SignupAuthCode,
        ];
      },
    },
  };
</script>

<style lang="scss" scoped>
  .registration {
    text-align: right;

    a {
      font-size: 1.5rem;
      color: $textColor;
    }
  }
</style>
